import React, { useState, useEffect } from 'react';
import Button from '../Button/Button';
import { useEscapeToClose } from '../../../hooks/useEscapeToClose';
import styles from './DateRangeModal.module.css';

interface DateRangeModalProps {
  open: boolean;
  onConfirm: (startDate: string, endDate: string) => void;
  onCancel: () => void;
  initialStart?: string;
  initialEnd?: string;
}

const DateRangeModal: React.FC<DateRangeModalProps> = ({
  open,
  onConfirm,
  onCancel,
  initialStart = '',
  initialEnd = '',
}) => {
  const [start, setStart] = useState(initialStart);
  const [end, setEnd] = useState(initialEnd);

  useEffect(() => {
    if (open) {
      if (initialStart || initialEnd) {
        setStart(initialStart);
        setEnd(initialEnd);
      } else {
        const today = new Date();
        const pad = (n: number) => String(n).padStart(2, '0');
        const fmt = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        const oneMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        setStart(fmt(oneMonthAgo));
        setEnd(fmt(today));
      }
    }
  }, [open, initialStart, initialEnd]);

  useEscapeToClose(onCancel, open);

  if (!open) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles['icon-circle']}>
          <span className="material-symbols-outlined">date_range</span>
        </div>

        <h3 className={styles.title}>Selecionar período</h3>

        <div className={styles.fields}>
          <div className={styles.field}>
            <label className={styles.label}>De:</label>
            <input
              type="date"
              className={styles.input}
              value={start}
              onChange={(e) => setStart(e.target.value)}
              autoFocus
            />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Até:</label>
            <input
              type="date"
              className={styles.input}
              value={end}
              onChange={(e) => setEnd(e.target.value)}
            />
          </div>
        </div>

        <div className={styles.actions}>
          <Button
            variant="ghost"
            size="small"
            className={styles['btn-action']}
            onClick={onCancel}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            size="small"
            className={styles['btn-action']}
            onClick={() => onConfirm(start, end)}
            disabled={!start && !end}
          >
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DateRangeModal;
